module.exports = __webpack_public_path__ + "public/images/generated-play-among-us.20b226553db844d6f2fcd8a8d385946d.jpg";